import type { FlightRoute } from 'common/packageCache';
import moment from 'moment';

function renderOperatingToCell(text: string, record: FlightRoute): string {
  return record.operatingTo ? moment(record.operatingTo).format('YYYY-MM-DD') : '';
}

export default renderOperatingToCell;
